/**
 * True when running in an environment suited to the multi-page capture scanner
 * (phone / tablet UA). Desktop browsers get a short “use your phone” message instead.
 *
 * Also honors Client Hints `navigator.userAgentData.mobile` when Android/iPhone tokens are
 * missing from a reduced User-Agent string (Chrome frozen UA / privacy experiments).
 */
export function isMobileScannerClient(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/android|iphone|ipad|ipod|mobile/i.test(ua)) return true;
  const ud = (navigator as Navigator & { userAgentData?: { mobile?: boolean } }).userAgentData;
  if (ud?.mobile === true) return true;
  return false;
}
